// images
import tr12 from "../../triangles/tr12.png"
import tr13 from "../../triangles/tr13.png"
import tr14 from "../../triangles/tr14.png"
import React from 'react';
import tr15 from "../../triangles/tr15.png"
import tr16 from "../../triangles/tr16.png"
// import tr17 from "../../triangles/tr17.png"
import tr18 from "../../triangles/tr18.png"

// Imports 
import { Skeleton, Stack, Typography } from "@mui/material";
import "./Media.scss"
import { useEffect, useState } from "react";

import ElfsightWidget from '../../components/ElfsightWidget/ElfsightWidget';


function Media() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  return (
    <div className="Media">
      <First />
      <Second />
    </div>
  );
}

function First() {
  if (localStorage.getItem("lang") === "en") {
    return (
      <div className="mFirst">

        <img src={tr12} alt="" className="tr12" />
        <img src={tr13} alt="" className="tr13" />
        <img src={tr14} alt="" className="tr14" />

        <div className="container">
          <Typography color="primary" sx={{
            fontWeight: "700",
            fontSize: "44px",
            lineHeight: "35px",
            textAlign: "center",
            mb: 8
          }}>
            Browse our videos
          </Typography>
          <Typography color="secondary" sx={{
            fontWeight: "700",
            fontSize: { xs: "35px", sm: "44px" },
            textAlign: "center",
            lineHeight: "35px",
          }}>
            to learn more about Lean Finance
          </Typography>
        </div>
      </div>
    );
  } else {
    return (
      <div className="mFirst">

        <img src={tr12} alt="" className="tr12" />
        <img src={tr13} alt="" className="tr13" />
        <img src={tr14} alt="" className="tr14" />

        <div className="container">
          <Typography color="primary" sx={{
            fontWeight: "700",
            fontSize: "44px",
            lineHeight: "35px",
            textAlign: "center",
            mb: 8
          }}>
            تصفح مقاطع الفيديو الخاصة بنا
          </Typography>
          <Typography color="secondary" sx={{
            fontWeight: "700",
            fontSize: { xs: "35px", sm: "44px" },
            textAlign: "center",
            lineHeight: "35px",
          }}>
            لمعرفة المزيد عن لين فايننس
          </Typography>
        </div>
      </div>
    );
  }
}


function Second() {

  const [loading, setloading] = useState(false)

  setTimeout(() => {
    setloading(true);
  }, 1000)

  if (localStorage.getItem("lang") === "en") {
    return (
      <div className="mSecond">

        <img src={tr15} alt="" className="tr15" />
        <img src={tr16} alt="" className="tr16" />
        {/* <img src={tr17} alt="" className="tr17" /> */}
        <img src={tr18} alt="" className="tr18" />

        {loading ? (
          <div className="container">
            <Stack spacing={13}>
              <iframe src="https://www.youtube.com/embed/UkorUKOaXNY?enablejsapi=1" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
                How to issue an E-Invoice on Lean Finance?
              </Typography>
            </Stack>
             <Stack spacing={13}>

              <iframe src="https://www.youtube.com/embed/e8TvNxVaBmg" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
                LeanDispatcher wins Best Tech Solution for Transport Companies – Saudi Ministry of Transport (2025).

              </Typography>
            </Stack>
            <Stack spacing={13}>
              <iframe src="https://www.youtube.com/embed/Paosjw_T9gU" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
                Ertikaz Solutions participates in INNOPROM Russia 2025 as part of the Saudi Pavilion
              </Typography>
            </Stack>
            <Stack spacing={13}>
              <iframe src="https://www.youtube.com/embed/p8EeU_LQxZ0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
                SaaS Scaling: Real-World Insights from Ertikaz Solutions COO & Co-Founder
              </Typography>
            </Stack>
          </div>
        ) : (
          <div className="container">
            <Stack spacing={13} >
              <Skeleton animation="wave" variant="rectangular" height="220px" />
              <Skeleton animation="wave" variant="rectangular" height="48px" sx={{ borderRadius: "14px" }} />
            </Stack>
            <Stack spacing={13} >
              <Skeleton animation="wave" variant="rectangular" height="220px" />
              <Skeleton animation="wave" variant="rectangular" height="48px" sx={{ borderRadius: "14px" }} />
            </Stack>
            <Stack spacing={13} >
              <Skeleton animation="wave" variant="rectangular" height="220px" />
              <Skeleton animation="wave" variant="rectangular" height="48px" sx={{ borderRadius: "14px" }} />
            </Stack>
          </div>
        )}

        <ElfsightWidget />

      </div>
    );
  } else {
    return (
      <div className="mSecond">

        <img src={tr15} alt="" className="tr15" />
        <img src={tr16} alt="" className="tr16" />
        {/* <img src={tr17} alt="" className="tr17" /> */}
        <img src={tr18} alt="" className="tr18" />

        {loading ? (
          <div className="container">
            <Stack spacing={13}>
              <iframe src="https://www.youtube.com/embed/UErqIIlHsDE?enablejsapi=1" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
                اسرع واسهل برنامج لي اصدار الفواتير الالكترونيه المعتمده من هيئه الزكاه
              </Typography>
            </Stack>
             <Stack spacing={13}>
              <iframe src="https://www.youtube.com/embed/e8TvNxVaBmg" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
لين ديسباتشر يفوز بجائزة أفضل حل تقني لشركات النقل – مقدمة من وزارة النقل السعودية
              </Typography>
            </Stack>
            <Stack spacing={13}>

              <iframe src="https://www.youtube.com/embed/Paosjw_T9gU" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
مشاركة Ertikaz Solutions في معرض INNOPROM روسيا 2025 ضمن الجناح السعودي
              </Typography>
            </Stack>
            <Stack spacing={13}>

              <iframe src="https://www.youtube.com/embed/p8EeU_LQxZ0" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "700",
                lineHeight: "20px",
                bgcolor: "secondary.main",
                py: 7,
                width: "100%",
                color: "white",
                textAlign: "center",
                borderRadius: "14px"
              }}>
                توسّع منصات SaaS: رؤى واقعية من الرئيس التنفيذي للعمليات والمؤسِّس المشارك لشركة Ertikaz Solutions

              </Typography>
            </Stack>
          </div>
        ) : (
          <div className="container">
            <Stack spacing={13} >
              <Skeleton animation="wave" variant="rectangular" height="220px" />
              <Skeleton animation="wave" variant="rectangular" height="48px" sx={{ borderRadius: "14px" }} />
            </Stack>
            <Stack spacing={13} >
              <Skeleton animation="wave" variant="rectangular" height="220px" />
              <Skeleton animation="wave" variant="rectangular" height="48px" sx={{ borderRadius: "14px" }} />
            </Stack>
            <Stack spacing={13} >
              <Skeleton animation="wave" variant="rectangular" height="220px" />
              <Skeleton animation="wave" variant="rectangular" height="48px" sx={{ borderRadius: "14px" }} />
            </Stack>
          </div>
        )}

        <ElfsightWidget />

      </div>
    );
  }
}



export default Media;